<template>
  <div class="swiperBox" style="margin-top:40px">
    <a-steps :current="stepNo" progress-dot>
      <a-step v-if="fillingInstruction === 'on'"><h3 slot="title">填报须知</h3></a-step>
      <a-step v-if="situation == 'on'"><h3 slot="title">情形选择</h3></a-step>
      <a-step v-if="formConfig == 'on'"><h3 slot="title">填报信息</h3></a-step>
      <a-step v-if="uploadMaterial == 'on'"><h3 slot="title">上传材料</h3></a-step>
      <a-step v-if="pickupMethod == 'on'"><h3 slot="title">取件方式</h3></a-step>
      <a-step v-if="inforMationConfirmed == 'on'"><h3 slot="title">信息确认</h3></a-step>
    </a-steps>
  </div>
</template>
<script>

import { jiopWebAPI } from '@/api/jiopweb/jiopweb'

export default {
  name: 'Step',
  components: {
  },
  props: {
  },
  created () {
    this.initStep()
  },
  data () {
    return {
      itemId: this.$route.query.itemId,
      fillingInstruction: 'off',
      formConfig: 'off',
      inforMationConfirmed: 'off',
      pickupMethod: 'off',
      situation: 'off',
      uploadMaterial: 'off',
      userAgreement: 'off',
      flowId: '',
      intelligentApproval: 'off',
      acceptFlowId: '',
      wholeIntelligentApproval: 'off',
      stepNo: parseInt(this.$route.query.stepNo),
      stepList: [{ name: 'fillInstruction', isOpen: false }, { name: 'selectSitution', isOpen: false },
        { name: 'matterForm', isOpen: false }, { name: 'uploadMaterial', isOpen: false },
        { name: 'receiveInfo', isOpen: false }, { name: 'confirmInfo', isOpen: false }],
      total: 0
    }
  },
  methods: {
    initStep () {
      const that = this
      this.total = 0
      jiopWebAPI.findReportConfigByIid({ itemid: this.itemId }).then(res => {
        if (res.success) {
          that.fillingInstruction = res.data.data.fillingInstruction
          that.formConfig = res.data.data.formConfig
          that.inforMationConfirmed = res.data.data.inforMationConfirmed
          that.pickupMethod = res.data.data.pickupMethod
          that.situation = res.data.data.situation
          that.uploadMaterial = res.data.data.uploadMaterial
          that.userAgreement = res.data.data.userAgreement
          that.flowId = res.data.data.flowId
          that.intelligentApproval = res.data.data.intelligentApproval ? res.data.data.intelligentApproval : 'off'
          that.acceptFlowId = res.data.data.acceptFlowId
          that.wholeIntelligentApproval = res.data.data.wholeIntelligentApproval ? res.data.data.wholeIntelligentApproval : 'off'
          if (that.fillingInstruction === 'on') {
            that.stepList[0].isOpen = true
            this.total++
          }
          if (that.situation === 'on') {
            that.stepList[1].isOpen = that.situation === 'on'
            this.total++
          }
          if (that.formConfig === 'on') {
            that.stepList[2].isOpen = that.formConfig === 'on'
            this.total++
          }
          if (that.uploadMaterial === 'on') {
            that.stepList[3].isOpen = that.uploadMaterial === 'on'
            this.total++
          }
          if (that.pickupMethod === 'on') {
            that.stepList[4].isOpen = that.pickupMethod === 'on'
            this.total++
          }
          if (that.inforMationConfirmed === 'on') {
            that.stepList[5].isOpen = that.inforMationConfirmed === 'on'
            this.total++
          }
          const ssList = []
          that.stepList.forEach(item => {
            if (item.isOpen) {
              ssList.push(item)
            }
          })
          that.stepList = ssList
          const userAgreementContent = res.data.data.userAgreementContent
          const fillingInstructionContent = res.data.data.fillingInstructionContent
          const pickType = res.data.data.pickupMethodContent
          const userAgreeMentName = res.data.data.userAgreeMentName
          sessionStorage.setItem(that.itemId + '_reportSystem', res.data.data.reportSystem)
          this.$emit('initContent', userAgreementContent, fillingInstructionContent, this.userAgreement, userAgreeMentName)
          this.$emit('initPickType', pickType)
        }
      })
    },
    nextStep () {
      this.stepNo = this.stepNo + 1
      this.findNextRouter()
    },
    findNextRouter () {
      if (this.stepList[this.stepNo].isOpen) {
        const router = '/' + this.stepList[this.stepNo].name
        console.log('11111', this.intelligentApproval)
        this.$router.push({
          path: router,
          query: {
            itemId: this.itemId,
            stepNo: this.stepNo,
            total: this.total,
            flowId: this.flowId,
            intelligentApproval: this.intelligentApproval,
            acceptFlowId: this.acceptFlowId,
            wholeIntelligentApproval: this.wholeIntelligentApproval,
            handleType: this.$route.query.handleType,
            materialList: this.$route.query.materialList,
            flagTag: this.$route.query.flagTag
          }
        })
      } else {
        this.stepNo++
        this.findNextRouter()
      }
    },
    previousStep () {
      this.stepNo = this.stepNo - 1
      this.findPreviousRouter()
    },
    findPreviousRouter () {
      if (this.stepList[this.stepNo].isOpen) {
        const router = '/' + this.stepList[this.stepNo].name
        this.$router.push({
          path: router,
          query: {
            itemId: this.itemId,
            stepNo: this.stepNo,
            total: this.total,
            flowId: this.flowId,
            intelligentApproval: this.intelligentApproval,
            acceptFlowId: this.acceptFlowId,
            wholeIntelligentApproval: this.wholeIntelligentApproval,
            handleType: this.$route.query.handleType,
            materialList: this.$route.query.materialList,
            flagTag: this.$route.query.flagTag
          }
        })
      } else {
        this.stepNo--
        this.findPreviousRouter()
      }
    }
  }

}
</script>
<style lang="less" scoped>
.swiperBox {
  box-shadow: 0px 2px 15px 0px rgba(153, 153, 153, 0.2);
  width: 1200px;
  height: 120px;
  background: #ffffff;
  padding: 37px;
  margin: auto;
}
</style>
